import "./App.css";
import { BrowserRouter, Switch, Redirect, Route } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import "../src/assests/css/Custom.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';

import Login from "./components/auth/Login";
import OtpVerification from "./components/auth/OtpVerification";
import CreateProfile from "./components/auth/CreateProfile"
import ClientPanel from "./components/clientPanel/ClientPanel";
import PublicRoute from "./router/PublicRoute";
import PrivateRoute from "./router/PrivateRoute";
import AdminPanel from "./components/adminPanel/AdminPanel";
import PageNotFound from "./components/errorHandler/PageNotFound";
import UnAuthroziedPage from "./components/errorHandler/UnAuthroziedPage";
import { getData } from "./utils/AsyncStorage";


function App() {

  const { role } = JSON.parse(getData("userInfo") || 0);


  return (
    <div className="App">
      <BrowserRouter>
      <ToastContainer
          autoClose={2000}
          hideProgressBar={true}
          position={toast.POSITION.TOP_CENTER}
        />
        {/* <library /> */}

        {/* <Login/> */}

        <Switch>
          {/* To directly route to auth components */}
          <Route exact path="/" render={() => <Redirect to="/login" />} />
          <Route exact path="/customerPortal" render={() => <Redirect to="/customerPortal/clientDashboard" />} />
          <Route exact path="/admin" render={() => <Redirect to="/admin/adminDashboard" />} />
          
          {/* ***Public routes is a component which has non authenticated path*** */}
          <PublicRoute exact restricted={true} component={Login} path="/login" />
          <PublicRoute exact restricted={true} component={OtpVerification} path={`/otpVerification`} />
          <PublicRoute exact restricted={false} component={CreateProfile} path={`/createProfile`} />
          <PrivateRoute  restricted={true} component={(props) => <ClientPanel {...props} roleId={role} />} path={`/customerPortal`}  />
          <PrivateRoute  restricted={true} component={(props) => <AdminPanel {...props} roleId={role} />} path={`/admin`} />
          
          <PublicRoute component={UnAuthroziedPage} path="/unauthorized" exact />
          <PublicRoute component={PageNotFound} path="*" exact />
        
         
          
        </Switch>
      </BrowserRouter>
    </div>

  );
}

export default App;
